import React from "react";
import Badge from ".";
import t from "../i18n";
import { colors } from "../Theme";

export function DevelopmentBadge() {
  return (
    <div>
      <Badge backgroundColor={colors.chlorine100} color={colors.carbon900}>
        {t("badge.in_development")}
      </Badge>
    </div>
  );
}
